import { Base64 } from 'js-base64'
import headlineBin from './headline.bin.json'
import headlinePrefab from './headline.prefab.json'
import headlineMeta from './headline.bin.meta.json'
import subtitleBin from './subtitle.bin.json'
import subtitlePrefab from './subtitle.prefab.json'
import subtitleMeta from './subtitle.bin.meta.json'
import bodyBin from './body.bin.json'
import bodyPrefab from './body.prefab.json'
import bodyMeta from './body.bin.meta.json'
import overlineBin from './overline.bin.json'
import overlinePrefab from './overline.prefab.json'
import overlineMeta from './overline.bin.meta.json'

export const subtitle = {
  type: 2,
  name: 'Subtitle',
  value: 'subtitle',
  fontSize: 24,
  files: [
    {
      name: 'subtitle.bin',
      data: Base64.encode(JSON.stringify(subtitleBin))
    },
    {
      name: 'subtitle.bin.meta',
      data: Base64.encode(JSON.stringify(subtitleMeta))
    },
    {
      name: 'subtitle.prefab',
      data: Base64.encode(JSON.stringify(subtitlePrefab))
    }
  ]
}

export function getTextPrefabList() {
  return [
    {
      type: 2,
      name: 'Headtitle',
      value: 'headline',
      fontSize: 36,
      files: [
        {
          name: 'headline.bin',
          data: Base64.encode(JSON.stringify(headlineBin))
        },
        {
          name: 'headline.bin.meta',
          data: Base64.encode(JSON.stringify(headlineMeta))
        },
        {
          name: 'headline.prefab',
          data: Base64.encode(JSON.stringify(headlinePrefab))
        }
      ]
    },
    subtitle,
    {
      type: 2,
      name: 'Body',
      value: 'body',
      fontSize: 14,
      files: [
        {
          name: 'body.bin',
          data: Base64.encode(JSON.stringify(bodyBin))
        },
        {
          name: 'body.bin.meta',
          data: Base64.encode(JSON.stringify(bodyMeta))
        },
        {
          name: 'body.prefab',
          data: Base64.encode(JSON.stringify(bodyPrefab))
        }
      ]
    },
    {
      type: 2,
      name: 'Overline',
      value: 'overline',
      fontSize: 8,
      files: [
        {
          name: 'overline.bin',
          data: Base64.encode(JSON.stringify(overlineBin))
        },
        {
          name: 'overline.bin.meta',
          data: Base64.encode(JSON.stringify(overlineMeta))
        },
        {
          name: 'overline.prefab',
          data: Base64.encode(JSON.stringify(overlinePrefab))
        }
      ]
    }
  ]
}
